export default "__VITE_ASSET__B5rEhr5J__"